"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var S = _interopRequireWildcard(require("./styled"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var SelectFilter = function SelectFilter(_ref) {
  var label = _ref.label,
      options = _ref.options,
      _ref$isMulti = _ref.isMulti,
      isMulti = _ref$isMulti === void 0 ? false : _ref$isMulti,
      column = _ref.column,
      onApplyFilters = _ref.onApplyFilters,
      state = _ref.state,
      gotoPage = _ref.gotoPage,
      _ref$selectedFilters = _ref.selectedFilters,
      selectedFilters = _ref$selectedFilters === void 0 ? [] : _ref$selectedFilters,
      defaultFilters = _ref.defaultFilters;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      selectedOptions = _useState2[0],
      setSelectedOptions = _useState2[1];

  var path = window.location.pathname;
  var claims = window.localStorage.getItem('claims');
  var user = claims ? JSON.parse(claims)['id'] : '';
  var defaultOptions = [];

  if (defaultFilters && defaultFilters[column.id]) {
    defaultOptions = options.filter(function (option) {
      return defaultFilters[column.id].includes(option.value);
    });
  }

  (0, _react.useEffect)(function () {
    var storedFilters = JSON.parse(window.localStorage.getItem("".concat(user, "_filterValues").concat(path)));

    if (storedFilters && storedFilters[column.id]) {
      var storedOptions = options.filter(function (option) {
        return storedFilters[column.id].includes(option.value);
      });
      setSelectedOptions(storedOptions);
    } else if (defaultFilters) {
      setSelectedOptions(defaultOptions);
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (selectedOptions && JSON.stringify(selectedOptions) !== JSON.stringify(defaultOptions)) {
      if (isMulti) {
        column.setFilter(selectedOptions.map(function (opt) {
          return opt.value;
        }));
      } else {
        column.setFilter(selectedOptions.value);
      }
    }
  }, [selectedOptions]);
  (0, _react.useEffect)(function () {
    // Clear filters on reset
    var hasOptions = isMulti ? selectedOptions.length > 0 : Object.keys(selectedOptions).length > 0;

    if (hasOptions && Object.keys(state[0].filters).length === 0) {
      setSelectedOptions(defaultOptions);
    }
  }, [state[0].filters]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, selectedFilters[column.id] && /*#__PURE__*/_react["default"].createElement(S.SelectFilter, null, /*#__PURE__*/_react["default"].createElement("label", null, label), /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "select-filter-".concat(label.toLowerCase().replaceAll(' ', '-'))
  }, /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], {
    className: "w-100",
    classNamePrefix: "list",
    value: selectedOptions,
    onChange: function onChange(opt) {
      if (!opt) opt = [];
      setSelectedOptions(opt);
    },
    onBlur: function onBlur() {
      onApplyFilters();
      gotoPage(0);
    },
    options: options,
    isMulti: isMulti
  }))));
};

SelectFilter.propTypes = {
  label: _propTypes["default"].string.isRequired,
  placeholder: _propTypes["default"].string,
  column: _propTypes["default"].shape({
    filterValue: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]),
    setFilter: _propTypes["default"].func.isRequired
  }),
  onApplyFilters: _propTypes["default"].func.isRequired,
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
    label: _propTypes["default"].string.isRequired
  })).isRequired,
  defaultFilters: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object])
};
var _default = SelectFilter;
exports["default"] = _default;